import highlighter from './highlighter';

export default {
  highlighter,
};
